"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationError = void 0;
var genericError_1 = require("./genericError");
/**
 * Ошибка валидации. Должна использоваться, когда аргументы не проходят валидацию.
 *
 * @example
 *
 * function fooHandler(req) {
 *    if (!req.header('X-RealUserId') || !req.header('X-Foo')) {
 *      throw new ValidationError({ message: 'Validation Error!', domain: 'fooHandler', details: {
 *        'X-Foo': req.header('X-Foo'),
 *        'X-RealUserId': req.header('X-RealUserId'),
 *      } });
 *    }
 * }
 *
 * @export
 * @class ValidationError
 * @extends {GenericError}
 */
var ValidationError = /** @class */ (function (_super) {
    __extends(ValidationError, _super);
    function ValidationError(_a) {
        var message = _a.message, domain = _a.domain, details = _a.details;
        var _this = _super.call(this, {
            type: 'ValidationError',
            message: message,
            domain: domain,
            details: details,
        }) || this;
        Object.setPrototypeOf(_this, ValidationError.prototype);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, ValidationError);
        }
        else {
            _this.stack = new Error().stack;
        }
        return _this;
    }
    return ValidationError;
}(genericError_1.GenericError));
exports.ValidationError = ValidationError;
//# sourceMappingURL=validationError.js.map